import { Fragment, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { XMarkIcon, ShoppingBagIcon, MinusIcon } from '@heroicons/react/24/outline'
import { PlusIcon } from '@heroicons/react/20/solid';

export default function Cart({ cart, setCart, handleChange }) {
    const [open, setOpen] = useState(false)

    // Handling the removal items in cart
    const handleRemove = (id) => {
      setCart((cart) => cart.filter((product) => product.id != id));
    };

    // Counting the unique items in cart
    let count = 0;
    for(let key in cart) {
      // increase the count
      ++count;
    }
    
    //Getting the total price of items in cart
    const price = cart.reduce(
      (total, product) => total + product.amount * product.price,
      0
    );

  return (
    <button type='button' onClick={() => setOpen(true)} className="text-sm font-semibold leading-6 text-gray-900 bg-white rounded-full shadow hover:shadow-md px-2.5 py-2">
    <div className='flex space-x-1'>
      <ShoppingBagIcon className="h-6 w-6 " aria-hidden="true"/>
      <p>{count}</p>
    </div>
    
            
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" open={open} onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                  <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
                  <div className="flex items-start justify-between px-4 py-4">
                        <Dialog.Title className="text-lg font-medium text-gray-900">Votre panier</Dialog.Title>
                        <div className="ml-3 flex h-7 items-center">
                          <button
                            type="button"
                            className="relative -m-2 p-2 text-gray-400 hover:text-gray-500"
                            onClick={() => setOpen(false)}>
                            <span className="absolute -inset-0.5" />
                            <span className="sr-only">Close panel</span>
                            <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                          </button>
                        </div>
                      </div>
                    <div className="flex-1 overflow-y-auto px-4 py-6 sm:px-6">
                      <div className="mt-0">
                        <div className="flow-root">
                          <ul className="-my-6 divide-y divide-gray-200">
                            {cart.map((product) => (
                              <li key={product.id} className="flex py-6">
                                <div className="h-24 w-24 flex-shrink-0 overflow-hidden rounded-md border border-gray-200">
                                  <img
                                    src={product.image}
                                    alt={product.slug}
                                    className="h-full w-full object-cover object-center"
                                  />
                                </div>

                                <div className="ml-4 flex flex-1 flex-col">
                                  <div>
                                    <div className="flex justify-between text-base font-medium text-gray-900">
                                      <h3>
                                        <a href={product.href}>{product.name}</a>
                                      </h3>
                                      <p className="ml-4">{product.price}$</p>
                                    </div>
                                    <p className="mt-1 text-sm text-gray-500">{product.color}</p>
                                  </div>
                                  <div className="flex flex-1 items-end justify-between text-sm">
                                    <ul class="inline-flex items-stretch -space-x-px">
                                          <li>
                                                <button onClick={() => handleChange(product.id, -1)} class="flex items-center justify-center h-full py-1 px-2 ml-0 text-gray-900 bg-white rounded-l-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 ">
                                                    <span className='font-bold'>
                                                      <MinusIcon className='w-2'/>
                                                    </span>
                                                </button>
                                            </li>
                                            <li>
                                                <p class="flex items-center justify-center text-sm py-1.5 px-2 leading-tight text-gray-900 bg-gray-100 border border-gray-300">{product.amount}</p>
                                            </li>
                                            <li>
                                                <button onClick={() => handleChange(product.id, 1)} class="flex items-center justify-center h-full py-1 px-2 leading-tight text-gray-900 bg-white rounded-r-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 ">
                                                    <span className='font-bold'>
                                                      <PlusIcon className='w-3'/>
                                                    </span>
                                                </button>
                                            </li>
                                        </ul>
                                    <div className="flex">
                                      <button onClick={() => handleRemove(product.id)}
                                        className="font-medium text-gray-600 hover:text-gray-500"
                                      >
                                        Retirer
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="border-t border-gray-200 px-4 py-4 sm:px-4">
                      <div className="flex justify-between text-base font-medium text-gray-900">
                        <p>Total</p>
                        <p>{price}$</p>
                      </div>
                      <div className="mt-4">
                        <a
                          // href="https://wa.me/+25776058950?text=urlencodedtext"
                          className="flex uppercase items-center justify-center rounded-md border border-transparent bg-gray-900 px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-gray-700"
                        >
                          Passer votre commande
                        </a>
                      </div>
                      <div className="mt-2 flex justify-center text-center text-sm text-gray-500">
                        <p>
                          <button
                            type="button"
                            className="pl-2 font-medium text-gray-700 hover:text-gray-500"
                            onClick={() => setOpen(false)}
                          >
                            Continuer vos achats
                            <span aria-hidden="true"> &rarr;</span>
                          </button>
                        </p>
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
    </button>
  )
}
